module.exports = __webpack_public_path__ + "img/XOM.495e0850.png";